export function getSlug(slug: string[]): string {
    return slug.at(-1) || ''
}

export function isActiveNavPath(pathname: string, navUrl: string): boolean {
    if (!navUrl) {
        return false
    }
    const normalizedPath = pathname.replace(/\/+$/, '')
    const normalizedNavUrl = navUrl.replace(/\/+$/, '')
    return normalizedPath === normalizedNavUrl || normalizedPath.startsWith(normalizedNavUrl + '/')
}

export function getContentfulEnvironment() {
    return process.env.CONTENTFUL_ENVIRONMENT;
}


export function formatDate(dateString: string) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
}

export const IS_DEBUG = process.env.DEBUG === '1';